import { apiUrl } from "../api/config";
import { assetCdnBaseUrl } from "../api/assets";
import { getBackgroundRemovalAsset, getBackgroundRemovalSource } from "./imageBackgroundRemoval";
import { withHandoutTransparentBackground } from "./handoutImagePython";
import { getOrRenderMatplotlibPreview } from "../shared/matplotlibPreviewCache";

export async function prepareHandoutBackgroundSource(image, { authToken, previewMatplotlibCode }) {
  const asset = getBackgroundRemovalAsset(image);
  if (asset.source_code && ["python", ""].includes(String(asset.source_language || "").toLowerCase())) {
    const result = await getOrRenderMatplotlibPreview(withHandoutTransparentBackground(asset.source_code), previewMatplotlibCode);
    if (!result?.success || !result.image) throw new Error(result?.error || "原圖重畫失敗，請檢查圖碼。");
    return result.image;
  }
  const source = getBackgroundRemovalSource(image);
  let key = String(asset.storage_key || "");
  try {
    const url = new URL(source);
    if (!key && url.origin === assetCdnBaseUrl) key = decodeURIComponent(url.pathname.replace(/^\//, ""));
  } catch { /* Data URLs and other ordinary images keep their existing path. */ }
  if (!key) return source;
  if (!authToken) throw new Error("請先登入後再讀取雲端原圖。");
  const response = await fetch(`${apiUrl}/assets/download/?${new URLSearchParams({ key })}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  if (!response.ok) throw new Error("雲端原圖讀取失敗，請確認素材仍存在或稍後再試。");
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("原圖無法讀取，請稍後再試。"));
    reader.readAsDataURL(blob);
  });
}
